import Vue from 'vue'
let VueEvent=new Vue();
export default VueEvent;


// WEBPACK FOOTER //
// ./src/models/VueEvent.js